module.exports = __webpack_public_path__ + "img/logo-title.513fff29.jpg";